import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { BranchProvider } from "@/context/BranchContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Disbursement from "@/pages/Disbursement";
import Outstanding from "@/pages/Outstanding";
import NetProfit from "@/pages/NetProfit";
import Loans from "@/pages/Loans";
import NewLoan from "@/pages/NewLoan";
import LoanDetail from "@/pages/LoanDetail";
import CustomerDetail from "@/pages/CustomerDetail";
import Customers from "@/pages/Customers";
import Payments from "@/pages/Payments";
import BranchLedger from "@/pages/BranchLedger";
import CollectionPriority from "@/pages/CollectionPriority";
import CollectionAction from "@/pages/CollectionAction";
import PromiseDetail from "@/pages/PromiseDetail";
import Handovers from "@/pages/Handovers";
import MonthlyIncome from "@/pages/MonthlyIncome";
import PotentialInterest from "@/pages/PotentialInterest";
import DataHealth from "@/pages/DataHealth";
import DeletedLoans from "@/pages/DeletedLoans";
import Account from "@/pages/Account";
import ActivityLog from "@/pages/ActivityLog";
import LoginRecords from "@/pages/LoginRecords";
import BadDebt from "@/pages/BadDebt";
import CollectorWorkbench from "@/pages/CollectorWorkbench";
import AccessControl from "@/pages/AccessControl";
import DirectorStatement from "@/pages/DirectorStatement";
import AllBranchesOverview from "@/pages/AllBranchesOverview";
import Commission from "@/pages/Commission";
import { InstallPrompt } from "@/components/InstallPrompt";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
      <AuthProvider>
        <BranchProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/disbursement" element={<ProtectedRoute><Disbursement /></ProtectedRoute>} />
            <Route path="/outstanding" element={<ProtectedRoute><Outstanding /></ProtectedRoute>} />
            <Route path="/net-profit" element={<ProtectedRoute><NetProfit /></ProtectedRoute>} />
            <Route path="/loans" element={<ProtectedRoute><Loans /></ProtectedRoute>} />
            <Route path="/loans/new" element={<ProtectedRoute editOnly><NewLoan /></ProtectedRoute>} />
            <Route path="/loans/:code" element={<ProtectedRoute><LoanDetail /></ProtectedRoute>} />
            <Route path="/customer" element={<ProtectedRoute><CustomerDetail /></ProtectedRoute>} />
            <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
            <Route path="/payments" element={<ProtectedRoute><Payments /></ProtectedRoute>} />
            <Route path="/ledger" element={<ProtectedRoute><BranchLedger /></ProtectedRoute>} />
            <Route path="/collection" element={<ProtectedRoute><CollectionPriority /></ProtectedRoute>} />
            <Route path="/collection/action" element={<ProtectedRoute><CollectionAction /></ProtectedRoute>} />
            <Route path="/collection/promise" element={<ProtectedRoute><PromiseDetail /></ProtectedRoute>} />
            <Route path="/handovers" element={<ProtectedRoute><Handovers /></ProtectedRoute>} />
            <Route path="/reports/monthly" element={<ProtectedRoute><MonthlyIncome /></ProtectedRoute>} />
            <Route path="/reports/interest" element={<ProtectedRoute><PotentialInterest /></ProtectedRoute>} />
            <Route path="/reports/data-health" element={<ProtectedRoute><DataHealth /></ProtectedRoute>} />
            <Route path="/deleted-loans" element={<ProtectedRoute><DeletedLoans /></ProtectedRoute>} />
            <Route path="/bad-debt" element={<ProtectedRoute><BadDebt /></ProtectedRoute>} />
            <Route path="/collectors" element={<ProtectedRoute><CollectorWorkbench /></ProtectedRoute>} />
            <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute allowedRoles={["director", "manager", "admin"]}><AccessControl /></ProtectedRoute>} />
            <Route path="/activity" element={<ProtectedRoute allowedRoles={["director", "manager", "admin"]}><ActivityLog /></ProtectedRoute>} />
            <Route path="/logins" element={<ProtectedRoute allowedRoles={["director", "manager", "admin"]}><LoginRecords /></ProtectedRoute>} />
            <Route path="/director/statement" element={<ProtectedRoute allowedRoles={["director", "manager", "admin"]}><DirectorStatement /></ProtectedRoute>} />
            <Route path="/director/overview" element={<ProtectedRoute allowedRoles={["director", "manager", "admin"]}><AllBranchesOverview /></ProtectedRoute>} />
            <Route path="/commission" element={<ProtectedRoute allowedRoles={["director", "manager", "admin"]}><Commission /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        </BranchProvider>
        <InstallPrompt />
        <Toaster position="top-right" richColors />
      </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
